import React from "react";
import { FolderIcon } from "@common/folderIcon";
import { InfiniteScroll } from "@common/infiniteScroll";

import { Props } from "./types";
import styles from "./styles.scss";

function sanitize(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function SearchResults({
  query,
  projects,
  canLoadMore,
  select,
  loadMore,
}: Props) {
  return (
    <div
      className={styles.searchResults}
      style={{ height: `calc(3.8rem * ${projects.length})` }}
    >
      <InfiniteScroll
        flags={[
          { name: "flag", retrieveItems: () => canLoadMore && loadMore() },
        ]}
        canFetchOnIdle={canLoadMore}
      >
        {({ flag }) => (
          <div className={styles.list}>
            {projects.map((project) => (
              <div
                key={project.uuid}
                className={styles.result}
                onClick={() => select(project)}
              >
                <FolderIcon className={styles.icon} isOpen={false} />
                <p
                  dangerouslySetInnerHTML={{
                    __html: project.name.replace(
                      new RegExp(sanitize(query), "ig"),
                      `<span class="${styles.match}">${query}</span>`,
                    ),
                  }}
                />
              </div>
            ))}
            {flag}
          </div>
        )}
      </InfiniteScroll>
    </div>
  );
}

export { SearchResults };
